<template>
  <div id="app">
    <TitleBar v-if="isShowTitleBar" :config="config"></TitleBar>
    <keep-alive :include="$store.state.keepAlivePages" max="5">
      <router-view></router-view>
    </keep-alive>
    <LoadingV1 v-if="loading"></LoadingV1>
    <!-- <TabBar></TabBar> -->
  </div>
</template>
<script>
// import TabBar from '@/components/index/TabBar'
import TitleBar from '@/base/TitleBar/TitleBar'
import loadMapMixin from '@/mixins/loadMapMixin'
// import partnerCardMixin from '@/mixins/partnerCardMixin'
import LoadingV1 from '@/base/loading/LoadingV1'
import { getQueryString, isMiniProgram } from '@/utils/tool'
import { defaultMenu } from '@/config/common'

export default {
  components: { TitleBar, LoadingV1 },
  mixins: [loadMapMixin],
  computed: {
    loading() {
      return this.$store.state.loading
    },
    config() {
      // return this.$store.state.titleBar
      return {
        ...this.$store.state.titleBar,
        menu: sessionStorage.getItem('channel') === '005_03_0001_0000_00' ? [defaultMenu[0], defaultMenu[2]] : defaultMenu
      }
    },
    isShowTitleBar() {
      return this.$route.meta.titleBar
      // 有些titleBar是有管理操作,所以要去掉!isMiniProgram()判断
      // return this.$route.meta.titleBar && !isMiniProgram()
    }
  }
}
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // router-view 需要满屏的自行加flex:1
}
</style>
